/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';

import {formatLongAbsoluteDate, formatShortDate} from '../../helpers/DateHelper'; 

class DropChart extends Component {

    render() {
        const points = this.props.points;

        const data = points.map((point, i) => {return { meta: "", labelx: point.timestamp, value: point.impactPerc }});

        const skipXLabel = (value, index) => {

            let startOffset = -1, step = -1, max = 0;
            for (let i = 0; i < points.length; i++) {
                max = Math.max(max, points[i].impactPerc);
                let date = new Date(points[i].timestamp);
                if (date.getHours() >= 9 && date.getHours() <= 14) {
                    if (startOffset === -1) {
                        startOffset = i;
                    } else if (step === -1 && (i - startOffset) > 4) {
                        step = (i - startOffset);
                    }
                }
            }
            step = Math.floor(points.length / 7);
            if (max > 50) max = 100;
            else if (max > 15) max = 50;
            else if (max > 5) max = 10;
            else if (max > 1) max = 5;
            else max = 1;

            if (index % step === startOffset) {
                return formatShortDate(new Date(value));
            }
            else return null;

        }

        let countFormatter = 0;

        const formatterX = (v) => {

            const value = skipXLabel(v, countFormatter);
            countFormatter++;
            if (value) {
                return value;
            }
            return "";
        }

        const formatterY = (value) => {
            if (Math.round(value) === value) {
                return value + '%';
            }
            return Number.parseFloat(value).toFixed(1) + '%';
        }

        const formatterTooltip = (value, name, props) => {
            return [parseFloat(value).toFixed(2) + "%", "Drop rate"];
        }

        const formatterLabelTooltip = (value) => {
            return formatLongAbsoluteDate(value);
        }

        return <ResponsiveContainer height={140}>
            <LineChart className="small" margin={{ top: 5, right: 5, bottom: 0, left: 0 }} data={data}>
                <Tooltip formatter={formatterTooltip} labelFormatter={formatterLabelTooltip} contentStyle={{"border-radius": "10px"}} />
                <XAxis dataKey="labelx" tickFormatter={formatterX} tickLine={false} axisLine={false} />
                <YAxis interval={0} domain={[0, 5]} tickFormatter={formatterY} tickLine={false} axisLine={false} />
                <Line type="monotone" dot={false} dataKey="value" stroke="#82ca9d" strokeWidth={2} />
            </LineChart>
        </ResponsiveContainer>
    }
}

export default DropChart;